var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeafIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_512_641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.05476 15.9452C4.05476 15.9452 10.6373 22.5278 16.3971 16.768C22.1568 11.0083 16.2025 5.05398 19.4141 0.585938C14.946 3.79754 8.99168 -2.1568 3.23195 3.60293C-2.52778 9.36266 4.05476 15.9452 4.05476 15.9452Z",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 0.585938L0.585938 19.4141",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8798 8.33831C18.8798 8.33831 17.8164 8.42991 16.7115 7.67679C15.451 6.81769 14.0445 5.95546 12.2397 7.76022C14.0444 5.95546 13.1822 4.54894 12.3231 3.28847C11.57 2.18347 11.6616 1.11987 11.6616 1.11987",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03018 1.06909C7.97979 6.74159 12.3854 7.61464 9.90893 10.091",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.966 12.0048C13.2935 12.0552 12.3854 7.61451 9.90894 10.091",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61766 13.3824C10.1639 9.83616 2.56575 8.21062 3.32637 3.50854",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61771 13.3823C10.1639 9.83608 11.7895 17.4342 16.4915 16.6736",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_512_641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafIcon);
export default __webpack_public_path__ + "static/media/leaf-icon.5f399788e7adee96fd9a9af8e86f52a5.svg";
export { ForwardRef as ReactComponent };